'use client';

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@ahafood/ui/components/avatar';
import { Button } from '@ahafood/ui/components/button';
import { Loader2, LogIn, User } from 'lucide-react';
import { ROUTES } from '@/config/router';
import { Link } from '@/i18n/routing';
import { useAuth } from '@/providers/auth-provider';
import { useAuthStore } from '@/store/use-auth-store';

export default function UserButton() {
  const { user, isAuthenticated, isLoading } = useAuthStore();
  const { login } = useAuth();

  if (isLoading) {
    return (
      <Button
        variant="outline"
        className="flex items-center justify-center rounded-xl size-10 h-12 md:h-14 min-w-fit text-brand-primary border-brand-primary bg-white/80 hover:bg-brand-primary hover:text-white transition-colors font-bold"
      >
        <Loader2 className="size-5 md:size-6 text-brand-primary animate-spin" />
      </Button>
    );
  }

  if (!isAuthenticated || !user) {
    return (
      <Button
        variant="outline"
        size="icon"
        onClick={(e) => {
          e.stopPropagation();
          login().catch((err) => console.error('login failed', err));
        }}
        className="flex items-center justify-center size-10 md:rounded-xl rounded-full md:h-14 min-w-fit font-bold text-brand-primary border-brand-primary bg-white/80 hover:bg-brand-primary hover:text-white transition-colors"
        aria-label="Đăng nhập"
      >
        <LogIn />
      </Button>
    );
  }

  const initial = user.name?.charAt(0).toUpperCase();

  return (
    <Link href={ROUTES.user} className="flex items-center md:pr-4">
      <Avatar className="size-10 md:size-13 shrink-0 hover:border-2 border-brand-primary group-hover:border-neutral-30 transition-colors">
        {user.picture ? (
          <AvatarImage
            src={user.picture}
            alt={user.name}
            className="object-cover"
          />
        ) : null}
        <AvatarFallback className="bg-primary-10 text-sm font-semibold text-primary-50">
          {initial ?? <User className="size-5" />}
        </AvatarFallback>
      </Avatar>
    </Link>
  );
}
